import { createSelector } from '@opengov/compose-app/reselect';
import { reportExplorerSelector } from '../../../reportExplorer/state';
import { lensSelector } from '../../../lenses/lensState';
import { selectPollReportLensesFlag } from '../../../common/flags';

export const selectReportDatasetLenses = createSelector(reportExplorerSelector, (state) => state?.reportDatasetLenses);
export const selectReportDatasetLensesStatus = createSelector(
  lensSelector,
  (state) => state?.reportDatasetLensesStatus
);
export const selectReportDataUpdateStatus = createSelector(
  selectReportDatasetLensesStatus,
  (datasetLenseStatus = []) => {
    const failed = datasetLenseStatus.some((lens) => lens?.ingestionStatus === 'INVALID');
    const inProgress = datasetLenseStatus.some((lens) => lens?.ingestionStatus === 'INPROGRESS');
    const success = datasetLenseStatus.some((lens) => lens?.ingestionStatus === 'COMPLETE');
    if (failed) return 'failed';
    if (inProgress) return 'inProgress';
    if (success) return 'success';
    return 'noStatus';
  }
);

export const selectReportDataUpdateStatusDate = createSelector(
  selectPollReportLensesFlag,
  selectReportDataUpdateStatus,
  selectReportDatasetLensesStatus,
  (isPollingDataUpdateStatus, dataUpdateStatus, datasetLenseStatus = []) => {
    if (isPollingDataUpdateStatus && datasetLenseStatus?.length && dataUpdateStatus === 'success') {
      const maxDateObject = datasetLenseStatus.reduce(
        (maxDate, item) => {
          const currentDate = new Date(item.dataUpdatedAt);
          return currentDate > maxDate.date ? { date: currentDate, dataUpdatedAt: item.dataUpdatedAt } : maxDate;
        },
        { date: new Date(0), dataUpdatedAt: '' }
      );
      return maxDateObject.dataUpdatedAt;
    }
    return '';
  }
);
